<template>
    <div class>
        <el-card class="box-card" shadow="hover">
            <div style="margin-bottom: 20px;">
                <el-button size="small" icon="el-icon-back" @click="$router.back()">返 回</el-button>
            </div>
            <el-form
                :inline="true"
                :rules="rules"
                :model="agentForm"
                ref="agentForm"
                label-position="right"
                label-width="140px"
            >
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="资质信息" name="withdraw">
                        <!-- 资质信息 -->
                        <template>
                            <div class="m-title">资质信息</div>
                            <div v-loading="imgLoading" element-loading-text="图片上传中,请稍等...." >
                                <el-form-item label="法人身份证正面照" prop="card_positive_img" style="display: inline-grid;">
                                    <el-upload disabled
                                        class="avatar-uploader"
                                        :show-file-list="false"
                                    >
                                        <img
                                            v-if="agentForm.card_positive_img_path != ''"
                                            :src="agentForm.card_positive_img_path"
                                            class="avatar"
                                        />
                                        <img
                                            v-else
                                            :src="require('../../assets/images/idcard_f3x.png')"
                                            class="avatar"
                                        />
                                    </el-upload>
                                </el-form-item>
                                <el-form-item label="法人身份证反面照" prop="card_negative_img" style="display: inline-grid;">
                                    <el-upload disabled
                                        class="avatar-uploader"
                                        :show-file-list="false"
                                    >
                                        <img
                                            v-if="agentForm.card_negative_img_path != ''"
                                            :src="agentForm.card_negative_img_path"
                                            class="avatar"
                                        />
                                        <img
                                            v-else
                                            :src="require('../../assets/images/idcard_r3x.png')"
                                            class="avatar"
                                        />
                                    </el-upload>
                                </el-form-item>
                                <el-form-item label="手持身份证照" prop="card_hand_hold_img" style="display: inline-grid;">
                                    <el-upload disabled
                                        class="avatar-uploader"
                                        :show-file-list="false"
                                    >
                                        <img
                                            v-if="agentForm.card_hand_hold_img_path != ''"
                                            :src="agentForm.card_hand_hold_img_path"
                                            class="avatar"
                                        />
                                        <img
                                            v-else
                                            :src="require('../../assets/images/hand_hold.jpg')"
                                            class="avatar"
                                        />
                                    </el-upload>
                                </el-form-item>
                                <el-form-item label="营业执照" prop="bus_license_img" style="display: inline-grid;">
                                    <el-upload disabled
                                        class="avatar-uploader"
                                        :show-file-list="false"
                                    >
                                        <img
                                            v-if="agentForm.bus_license_img != ''"
                                            :src="agentForm.bus_license_img_path"
                                            class="avatar"
                                        />
                                        <img
                                            v-else
                                            :src="require('../../assets/images/permit3x.png')"
                                            class="avatar"
                                        />
                                    </el-upload>
                                </el-form-item>
                                <el-form-item label="结算银行卡照" prop="settle_card_img" style="display: inline-grid;">
                                    <el-upload disabled
                                        class="avatar-uploader"
                                        :show-file-list="false"
                                    >
                                        <img
                                            v-if="agentForm.settle_card_img_path != ''"
                                            :src="agentForm.settle_card_img_path"
                                            class="avatar"
                                        />
                                        <img
                                            v-else
                                            :src="require('../../assets/images/card.jpg')"
                                            class="avatar"
                                        />
                                    </el-upload>
                                </el-form-item>
                                <el-form-item label="开户许可证" prop="opening_permit_img" style="display: inline-grid;">
                                    <el-upload disabled
                                        class="avatar-uploader"
                                        :show-file-list="false"
                                    >
                                        <img
                                            v-if="agentForm.opening_permit_img_path != ''"
                                            :src="agentForm.opening_permit_img_path"
                                            class="avatar"
                                        />
                                        <img
                                            v-else
                                            :src="require('../../assets/images/opening.jpg')"
                                            class="avatar"
                                        />
                                    </el-upload>
                                </el-form-item>         
                                <el-form-item label="门店门头照" prop="store_door_img" style="display: inline-grid;"  label-position="left" label-width="130px">
                                    <el-upload
                                        class="avatar-uploader"
                                    disabled
                                        :show-file-list="false"
                                    >
                                        <img
                                            v-if="agentForm.store_door_img_path != ''"
                                            :src="agentForm.store_door_img_path"
                                            class="avatar"
                                        />
                                        <img
                                            v-else
                                            :src="require('../../assets/images/other3x.png')"
                                            class="avatar"
                                        />
                                    </el-upload>
                                </el-form-item>
                                <el-form-item label="店内环境照片" prop="store_environment_img" style="display: inline-grid;"  label-position="left" label-width="150px">
                                    <el-upload
                                        class="avatar-uploader"
                                        disabled
                                        :show-file-list="false"
                                    >
                                        <img
                                            v-if="agentForm.store_environment_img_path != ''"
                                            :src="agentForm.store_environment_img_path"
                                            class="avatar"
                                        />
                                        <img
                                            v-else
                                            :src="require('../../assets/images/other3x.png')"
                                            class="avatar"
                                        />
                                    </el-upload>
                                </el-form-item>
                                <el-form-item label="商户合同文件" prop="merchant_contract_img" style="display: inline-grid;"  label-position="left" label-width="150px">
                                    <el-upload
                                        class="avatar-uploader"
                                        disabled
                                        :show-file-list="false"
                                    >
                                        <img
                                            v-if="agentForm.merchant_contract_img_path != ''"
                                            :src="agentForm.merchant_contract_img_path"
                                            class="avatar"
                                        />
                                        <img
                                            v-else
                                            :src="require('../../assets/images/other3x.png')"
                                            class="avatar"
                                        />
                                    </el-upload>
                                </el-form-item>
                                <el-form-item label="结算声明" prop="statement_settlement_img" style="display: inline-grid;"  label-position="left" label-width="130px">
                                    <el-upload
                                        class="avatar-uploader"
                                        disabled
                                        :show-file-list="false"
                                    >
                                        <img
                                            v-if="agentForm.statement_settlement_img_path != ''"
                                            :src="agentForm.statement_settlement_img_path"
                                            class="avatar"
                                        />
                                        <img
                                            v-else
                                            :src="require('../../assets/images/other3x.png')"
                                            class="avatar"
                                        />
                                    </el-upload>
                                </el-form-item>
                                <el-form-item label="其他文件" prop="other_documents_img" style="display: inline-grid;"  label-position="left" label-width="130px">
                                    <el-upload
                                        class="avatar-uploader"
                                        disabled
                                        :show-file-list="false"
                                    >
                                        <img
                                            v-if="agentForm.other_documents_img_path != ''"
                                            :src="agentForm.other_documents_img_path"
                                            class="avatar"
                                        />
                                        <img
                                            v-else
                                            :src="require('../../assets/images/other3x.png')"
                                            class="avatar"
                                        />
                                    </el-upload>
                                </el-form-item>
                                <el-form-item label="手写签名" prop="handwritten_signature_img" style="display: inline-grid;"  label-position="left" label-width="130px">
                                    <el-upload
                                        class="avatar-uploader"
                                        disabled
                                        :show-file-list="false"
                                    >
                                        <img
                                            v-if="agentForm.handwritten_signature_img_path != ''"
                                            :src="agentForm.handwritten_signature_img_path"
                                            class="avatar"
                                        />
                                        <img
                                            v-else
                                            :src="require('../../assets/images/other3x.png')"
                                            class="avatar"
                                        />
                                    </el-upload>
                                </el-form-item>
                                <el-form-item label="签约文件照片" prop="signing_documents_img" style="display: inline-grid;"  label-position="left" label-width="130px">
                                    <el-upload
                                        class="avatar-uploader"
                                        disabled
                                        :show-file-list="false"
                                    >
                                        <img
                                            v-if="agentForm.signing_documents_img_path != ''"
                                            :src="agentForm.signing_documents_img_path"
                                            class="avatar"
                                        />
                                        <img
                                            v-else
                                            :src="require('../../assets/images/other3x.png')"
                                            class="avatar"
                                        />
                                    </el-upload>
                                </el-form-item>
                                <el-form-item label="门店收银台" prop="store_cashier_img" style="display: inline-grid;"  label-position="left" label-width="130px">
                                    <el-upload
                                        class="avatar-uploader"
                                        disabled
                                        :show-file-list="false"
                                    >
                                        <img
                                            v-if="agentForm.store_cashier_img_path != ''"
                                            :src="agentForm.store_cashier_img_path"
                                            class="avatar"
                                        />
                                        <img
                                            v-else
                                            :src="require('../../assets/images/other3x.png')"
                                            class="avatar"
                                        />
                                    </el-upload>
                                </el-form-item>
                                <el-form-item label="经营场所产权证明/租赁合同" prop="securities_img" style="display: inline-grid;"  label-position="left" label-width="190px">
                                    <el-upload
                                        class="avatar-uploader"
                                        disabled
                                        :show-file-list="false"
                                    >
                                        <img
                                            v-if="agentForm.securities_img_path != ''"
                                            :src="agentForm.securities_img_path"
                                            class="avatar"
                                        />
                                        <img
                                            v-else
                                            :src="require('../../assets/images/other3x.png')"
                                            class="avatar"
                                        />
                                    </el-upload>
                                </el-form-item>               
                            </div>
                        </template>
                    </el-tab-pane>
                    <el-tab-pane label="基本信息" name="withdra">
                        <!-- 基本信息 -->
                        <template>
                            <div class="m-title">基本信息</div>
                            <el-form-item label="商户类型" prop="mch_type">
                                <el-select size="medium" v-model="agentForm.mch_type" placeholder="请选择商户类型" disabled>
                                    <el-option label="个体商户" value="1"></el-option>
                                    <el-option label="企业商户" value="0" disabled></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="账户类型" prop="account_type">
                                <el-select disabled
                                    size="medium"
                                    v-model="agentForm.account_type"
                                    placeholder="请选择账户类型"
                                >
                                    <el-option label="对私" value="0"></el-option>
                                    <el-option label="对公" value="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <br />
                            <el-form-item label="商户名称" prop="mch_name">
                                <el-input disabled
                                    size="medium"
                                    suffix-icon="el-icon-aux"
                                    v-model="agentForm.mch_name"
                                    placeholder="请输入商户名称"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="法人姓名" prop="legal_person">
                                <el-input disabled
                                    size="medium"
                                    suffix-icon="el-icon-aux"
                                    v-model="agentForm.legal_person"
                                    placeholder="请输入法人姓名"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="法人手机号" prop="legal_phone">
                                <el-input disabled
                                    size="medium"
                                    suffix-icon="el-icon-aux"
                                    v-model="agentForm.legal_phone"
                                    placeholder="请输入法人手机号"
                                ></el-input>
                            </el-form-item>
                            <br>
                            <el-form-item label="证件号" prop="id_card">
                                <el-input disabled
                                    size="medium"
                                    suffix-icon="el-icon-aux"
                                    v-model="agentForm.id_card"
                                    placeholder="请输入证件号"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="证件有效期" prop="card_valid_sdate">
                                <el-date-picker disabled
                                    v-model="cardRange"
                                    type="daterange"
                                    :clearable="false"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format="yyyy-MM-dd"
                                ></el-date-picker>
                                <span style="margin-left:10px">
                                    <el-checkbox disabled
                                        :true-label="1"
                                        :false-label="0"
                                        v-model="is_long_time"
                                    >长期</el-checkbox>
                                </span>
                            </el-form-item>
                            <br />
                            <el-form-item label="商户经营地址" prop="union_pay_code" style="width:472px;">
                                <el-select  style="width:90px;" disabled
                                    size="medium"
                                    v-model="agentForm.prov_name"
                                    filterable

                                    placeholder="省"
                                >
                                    <el-option
                                        v-for="item in proList"
                                        :label="item.name"
                                        :value="item.code"
                                        :key="item.code"
                                    ></el-option>
                                </el-select>
                                <el-select style="width:90px;" disabled
                                    size="medium"
                                    v-model="agentForm.city_name"
                                    filterable

                                    placeholder="市"
                                >
                                    <el-option
                                        v-for="item in cityList"
                                        :label="item.name"
                                        :value="item.code"
                                        :key="item.code"
                                    ></el-option>
                                </el-select>
                                <el-select style="width:90px;" disabled
                                    size="medium"
                                    v-model="agentForm.area_name"
                                    filterable

                                    placeholder="区"
                                >
                                    <el-option
                                        v-for="item in countyList"
                                        :label="item.name"
                                        :value="item.code"
                                        :key="item.code"
                                    ></el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="" prop="addr_detail">
                                <el-input style="width:536px" disabled
                                    size="medium"
                                    suffix-icon="el-icon-aux"
                                    v-model="agentForm.addr_detail"
                                    placeholder="请输入详细地址,至少包含【号、室、组、弄、巷、栋、房、交叉口】其中之一"
                                ></el-input>
                            </el-form-item>
                            <br>
                            <el-form-item label="统一社会信用代码" prop="credit_code">
                                <el-input disabled
                                    size="medium"
                                    suffix-icon="el-icon-aux"
                                    v-model="agentForm.credit_code"
                                    placeholder="请输入统一社会信用代码"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="营业执照有效期" prop="bus_license_valid_sdate">
                                <el-date-picker disabled
                                    v-model="licenseRange"
                                    type="daterange"
                                    :clearable="false"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format="yyyy-MM-dd"
                                ></el-date-picker>
                                <span style="margin-left:10px">
                                    <el-checkbox disabled
                                        :true-label="1"
                                        :false-label="0"
                                        v-model="is_bus_license_long_time"
                                    >长期</el-checkbox>
                                </span>
                            </el-form-item>
                            <br />
                            <el-form-item label="注册资本(元)" prop="reg_capital">
                                <el-input disabled
                                    size="medium"
                                    suffix-icon="el-icon-aux"
                                    v-model="agentForm.reg_capital"
                                    placeholder="企业商户必填"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="经营类别" prop="mcc">
                                <el-select disabled
                                    size="medium"
                                    v-model="agentForm.custom_code"
                                    filterable
                                    placeholder="经营类别"
                                >
                                    <el-option
                                        v-for="item in mccList"
                                        :label="item.name"
                                        :value="item.code"
                                        :key="item.code"
                                    ></el-option>
                                </el-select>
                                <el-select disabled
                                    size="medium"
                                    v-model="agentForm.mcc_name"
                                    filterable
                                    placeholder="经营类别"
                                >
                                    <el-option
                                        v-for="item in mccsList"
                                        :label="item.name"
                                        :value="item.mcc"
                                        :key="item.mcc"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="经营范围" prop="business">
                                <el-input style="width:350px" disabled
                                    size="medium"
                                    suffix-icon="el-icon-aux"
                                    v-model="agentForm.business"
                                    placeholder="请输入经营范围"
                                ></el-input>
                            </el-form-item>

                        </template>
                    </el-tab-pane>
                        <!-- 结算信息 -->
                    <el-tab-pane label="结算信息" name="withdr">
                        <template>
                            <div class="m-title">结算信息&nbsp;&nbsp;<span style="font-size:12px;color:red;">【对私账户必须为法人的账户】</span></div>
                            <el-form-item label="银行账户名称" prop="account_name">
                                <el-input disabled
                                    size="medium"
                                    suffix-icon="el-icon-aux"
                                    placeholder="请填写银行户名"
                                    v-model="agentForm.account_name"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="银行名称" prop="bank_name">
                                <el-select disabled
                                    size="medium"
                                    v-model="agentForm.bank_name"
                                    filterable
                                    placeholder="请选择银行名称"
                                >
                                    <el-option
                                        v-for="item in bankList"
                                        :label="item.bank_name"
                                        :value="item.bank_name"
                                        :key="item.bank_name"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <br>
                            <el-form-item label="银行归属地区" prop="bank_prov">
                                <el-select disabled
                                    size="medium"
                                    v-model="agentForm.bank_prov"
                                    filterable
                                    placeholder="请选择银行归属地区"
                                >
                                    <el-option
                                        v-for="item in addressList"
                                        :label="item.name"
                                        :value="item.name"
                                        :key="item.name"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="结算支行名称" prop="branch_bank">
                                <el-select disabled
                                    size="medium"
                                    v-model="agentForm.branch_bank"
                                    filterable
                                    placeholder="请选择结算支行名称"
                                >
                                    <el-option
                                        v-for="item in branchList"
                                        :label="item.bank_branch"
                                        :value="item.bank_branch"
                                        :key="item.bank_branch"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <br>
                            <el-form-item label="联行号" prop="line_num">
                                <el-input disabled
                                    size="medium"
                                    suffix-icon="el-icon-aux"
                                    v-model="agentForm.line_num"
                                    placeholder="请输入联行号"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="银行账号" prop="bank_code">
                                <el-input disabled
                                    size="medium"
                                    suffix-icon="el-icon-aux"
                                    v-model="agentForm.bank_code"
                                    placeholder="请输入银行账号"
                                ></el-input>
                            </el-form-item>
                        </template>
                    </el-tab-pane>
                </el-tabs>
            </el-form>
        </el-card>
    </div>
</template>

<script>
import rules from './addAgentValid';
export default {
    data() {
        return {
            activeName: 'withdraw',
            licenseRange: [],   // 营业执照有效期
            cardRange: [],      // 身份证有效期
            uploadUrl: this.$api.uploadUrl, // 上传图片的地址
            loading: false,     // 提交loading
            imgLoading: false,  // 上传图片loading
            isSelect: false,    // 根据是否选中长期来判断身份证截止日期是否可选
            isSelect2: false,   // 根据是否选中长期来判断营业执照截止日期是否可选
            mccList:[],         // mcc
            mccsList:[],
            addressList:[],     // 省市区
            bankList: [],       // 银行列表
            branchList: [],     // 银行支行列表
            proList:[],
            cityList:[],
            countyList:[],
            is_bus_license_long_time: 0,    // 是否长期 营业执照
            is_long_time: 0,                // 是否长期 身份证
            is_show_open:'0',
            is_show_card:'1',
            agentForm: {
                card_positive_img: '',      // 身份证正面
                card_positive_img_path: '', // 身份证正面--展示
                card_negative_img: '',      // 身份证反面
                card_negative_img_path: '', // 身份证反面--展示
                bus_license_img: '',        // 营业执照 照片
                bus_license_img_path: '',   // 营业执照 照片--展示
                opening_permit_img: '',     // 开户许可照片
                opening_permit_img_path: '',// 开户许可照片--展示
                card_hand_hold_img:'',      // 手持身份证
                card_hand_hold_img_path:'', // 手持身份证--展示
                settle_card_img:'',         // 结算银行卡
                settle_card_img_path:'',    // 结算银行卡--展示
                store_door_img:'',              //门店门头照
                store_door_img_path:'',
                store_environment_img:'',   //店内环境照片
                store_environment_img_path:'',
                merchant_contract_img:'',   //商户合同文件
                merchant_contract_img_path:'',
                statement_settlement_img:'',    //结算声明
                statement_settlement_img_path:'',
                other_documents_img:'', //其他文件
                other_documents_img_path:'',
                handwritten_signature_img:'',   //手写签名
                handwritten_signature_img_path:'',
                signing_documents_img:'',   //签约文件照片
                signing_documents_img_path:'',
                store_cashier_img:'',       //门店收银台
                store_cashier_img_path:'',
                securities_img:'',          //经营场所产权证明
                securities_img_path:'',

                mch_type:this.$route.query.merchant_type,//代理角色
                mch_name: '',               // 代理名
                legal_person: '',           // 法人
                legal_company:'',           // 公司名称
                legal_phone: '',            // 法人手机号
                id_card: '',                // 身份证
                card_valid_sdate: '',       // 身份证开始时间
                card_valid_edate: '',       // 身份证结束时间

                prov_code:"",               // 省代码
                city_code:"",               // 市代码
                area_code:"",               // 区代码
                prov_name:"",               // 省
                city_name:"",               // 市
                area_name:"",               // 区
                view_business_addr:'',      // 省市区
                addr_detail:"",             // 详细地址
                union_pay_code:'',

                credit_code:this.$route.query.license_no,//营业执照信用代码

                bus_license_valid_sdate: '',// 营业执照开始时间
                bus_license_valid_edate: '',// 营业执照结束时间
                reg_capital:'',             // 注册资本
                business:'',                // 经营范围
                custom_code:'',
                mcc:'',
                mcc_name:'',

                account_type: '0',          // 账户类型
                account_name: '',           // 账户名
                bank_name: '',              // 银行id
                bank_prov:'',               // 银行所在省
                line_num: '',               // 联行号
                bank_code: '',              // 银行卡号
                branch_bank: '',            // 分行名
                bankSign: '',               // 选中银行的标识
            },
            rules: rules
        }
    },
    watch: {
        'agentForm.account_type'(newVal) { // 监听账户类型
            if (newVal == 0) {//对私
                this.is_show_open=0;
                this.is_show_card=1;
                this.agentForm.account_name = this.agentForm.legal_person;
            } else {
                this.is_show_open=1;
                this.is_show_card=0;
                this.agentForm.account_name = this.agentForm.legal_company;
            }
        },
        // 'agentForm.legal_person'(newVal) { // 监听代理商名称--银行账户名称与代理商名称一致--对私
        //     this.agentForm.account_name = newVal;
        // },
    },
    created() {
        this.getBank(); //获取银行列表
        this.getAddress(); //获取地址列表
        this.getProAddress(); //获取地址列表
        this.getMcc(); //获取MCC列表
        this.getIni(); //获取MCC列表
    },
    mounted() {
        // this.uploadUrl = this.$api.uploadUrl;//上传文件地址
    },
    methods: {
        getBranch() { // 获取支行
            this.$api.post('bank/branch', { bank_symbol: this.agentForm.bankSign, bank_prov: this.agentForm.bank_prov }, res => {
                if (res.code == 0) {
                    this.agentForm.line_num = '';
                    this.branchList = [];
                    this.branchList = res.data.bank;
                } else {
                    this.$message.error('获取支行信息失败，请重新选择银行或归属地进行获取!');
                }
            });
        },
        getBank() { // 获取银行列表
            this.$api.post("bank/list", {}, res => {
                if (res.code == 0) {
                    this.bankList = res.data;
                }
            })
        },
        getAddress() { // 获取银行省列表
            this.$api.post("MerchantNet/getAddr", {}, res => {
                if (res.code == 0) {
                    this.addressList = res.data;
                }
            })
        },
        getProAddress() { // 获取银行省列表
            this.$api.post("MerchantNet/getAddr", {}, res => {
                if (res.code == 0) {
                    this.proList = res.data;
                }
            })
        },
        getMcc() { // 获取mcc列表
            this.$api.post("MerchantNet/getMcc", {}, res => {
                if (res.code == 0) {
                    this.mccList = res.data;
                }
            })
        },
        getIni() { // 获取redis信息
            this.$api.post("merchant_company/getCompanyMerchantNetCache", {license_no:this.agentForm.credit_code,mch_type:this.agentForm.mch_type}, res => {
                if (res.code == 0) {
                    var list=res.data;
                    if(list.card_positive_img){this.agentForm.card_positive_img=list.card_positive_img;this.agentForm.card_positive_img_path=list.card_positive_img_path;};      // 身份证正面
                    if(list.card_negative_img){this.agentForm.card_negative_img=list.card_negative_img;this.agentForm.card_negative_img_path=list.card_negative_img_path;};      // 身份证反面
                    if(list.bus_license_img){this.agentForm.bus_license_img=list.bus_license_img;this.agentForm.bus_license_img_path=list.bus_license_img_path;};      // 营业执照
                    if(list.opening_permit_img){this.agentForm.opening_permit_img=list.opening_permit_img;this.agentForm.opening_permit_img_path=list.opening_permit_img_path;};      // 开户许可照片
                    if(list.card_hand_hold_img){this.agentForm.card_hand_hold_img=list.card_hand_hold_img;this.agentForm.card_hand_hold_img_path=list.card_hand_hold_img_path;};      // 手持身份证
                    if(list.settle_card_img){this.agentForm.settle_card_img=list.settle_card_img;this.agentForm.settle_card_img_path=list.settle_card_img_path;};      // 结算银行卡
                    if(list.store_door_img){this.agentForm.store_door_img=list.store_door_img;this.agentForm.store_door_img_path=list.store_door_img_path;};      // 结算银行卡
                    if(list.store_environment_img){this.agentForm.store_environment_img=list.store_environment_img;this.agentForm.store_environment_img_path=list.store_environment_img_path;};      // 结算银行卡
                    if(list.merchant_contract_img){this.agentForm.merchant_contract_img=list.merchant_contract_img;this.agentForm.merchant_contract_img_path=list.merchant_contract_img_path;};      // 结算银行卡
                    if(list.statement_settlement_img){this.agentForm.statement_settlement_img=list.statement_settlement_img;this.agentForm.statement_settlement_img_path=list.statement_settlement_img_path;};      // 结算银行卡
                    if(list.other_documents_img){this.agentForm.other_documents_img=list.other_documents_img;this.agentForm.other_documents_img_path=list.other_documents_img_path;};      // 结算银行卡
                    if(list.handwritten_signature_img){this.agentForm.handwritten_signature_img=list.handwritten_signature_img;this.agentForm.handwritten_signature_img_path=list.handwritten_signature_img_path;};      // 结算银行卡
                    if(list.signing_documents_img){this.agentForm.signing_documents_img=list.signing_documents_img;this.agentForm.signing_documents_img_path=list.signing_documents_img_path;};      // 结算银行卡
                    if(list.store_cashier_img){this.agentForm.store_cashier_img=list.store_cashier_img;this.agentForm.store_cashier_img_path=list.store_cashier_img_path;};      // 结算银行卡
                    if(list.securities_img){this.agentForm.securities_img=list.securities_img;this.agentForm.securities_img_path=list.securities_img_path;};      // 结算银行卡

                    if(list.mch_type){this.agentForm.mch_type=list.mch_type;};      // 商户角色
                    if(list.mch_name){this.agentForm.mch_name=list.mch_name;};      // 商户名称
                    if(list.legal_person){this.agentForm.legal_person=list.legal_person;};      // 法人
                    if(list.legal_phone){this.agentForm.legal_phone=list.legal_phone;};      // 法人手机号
                    if(list.id_card){this.agentForm.id_card=list.id_card;};      // 身份证
                    if(list.card_valid_edate){
                        this.agentForm.card_valid_sdate=list.card_valid_sdate;// 身份证开始时间
                        this.agentForm.card_valid_edate=list.card_valid_edate;// 身份证结束时间
                        this.cardRange=[list.card_valid_sdate,list.card_valid_edate];      // 身份证有效期
                        if(list.card_valid_edate=="9999-01-01"){
                            this.isSelect=true;
                            this.is_long_time=1;
                        }
                    };

                    if(list.prov_code){
                        this.agentForm.prov_code=list.prov_code;
                        this.$api.post("MerchantNet/getAddr", {parent_code:list.prov_code}, res => {
                            if (res.code == 0) {
                                this.countyList = res.data;
                            }
                        })
                    };      // 省代码
                    if(list.city_code){
                        this.agentForm.city_code=list.city_code;
                        this.$api.post("MerchantNet/getAddr", {parent_code:list.city_code}, res => {
                            if (res.code == 0) {
                                this.countyList = res.data;
                            }
                        })
                    };      // 市代码
                    if(list.area_code){this.agentForm.area_code=list.area_code;};      // 区代码
                    if(list.prov_name){this.agentForm.prov_name=list.prov_name;};      // 省
                    if(list.city_name){this.agentForm.city_name=list.city_name;};      // 市
                    if(list.area_name){this.agentForm.area_name=list.area_name;};      // 区
                    if(list.view_business_addr){this.agentForm.view_business_addr=list.view_business_addr;};      // 省市区
                    if(list.addr_detail){this.agentForm.addr_detail=list.addr_detail;};      // 详细地址
                    if(list.union_pay_code){this.agentForm.union_pay_code=list.union_pay_code;};      // 地区码

                    if(list.credit_code){this.agentForm.credit_code=list.credit_code;};      // 营业执照信用代码
                    if(list.reg_capital){this.agentForm.reg_capital=list.reg_capital;};      // 注册资本
                    if(list.business){this.agentForm.business=list.business;};      // 经营范围
                    if(list.mcc){
                        this.agentForm.mcc_name=list.mcc_name;
                        this.agentForm.custom_code=list.custom_code;
                        this.agentForm.mcc=list.mcc;
                        this.$api.post("MerchantNet/getMcc", {custom_code:list.custom_code,is_personal:list.mch_type}, res => {
                            if (res.code == 0) {
                                this.mccsList = res.data;
                            }
                        })
                    };      // 地区码
                    if(list.bus_license_valid_edate){
                        this.agentForm.bus_license_valid_sdate=list.bus_license_valid_sdate;// 营业执照开始时间
                        this.agentForm.bus_license_valid_edate=list.bus_license_valid_edate;// 营业执照结束时间
                        this.licenseRange=[list.bus_license_valid_sdate,list.bus_license_valid_edate];      // 营业执照有效期
                        if(list.bus_license_valid_edate=="9999-01-01"){
                            this.isSelect2=true;
                            this.is_bus_license_long_time=1;
                        }
                    };

                    if(list.legal_company){this.agentForm.legal_company=list.legal_company;};      // 账户名
                    if(list.account_name){this.agentForm.account_name=list.account_name;};      // 账户名
                    if(list.bank_name){this.agentForm.bank_name=list.bank_name;};      // 银行名称
                    if(list.account_type){
                        this.agentForm.account_type=list.account_type;
                        if(list.account_type==0){
                            this.is_show_open=0;
                            this.is_show_card=1;
                            // this.agentForm.account_name = list.legal_person;
                        }
                        if(list.account_type==2){
                            this.is_show_open=1;
                            this.is_show_card=0;
                            // this.agentForm.account_name = list.legal_company;
                        }
                    };      // 银行名称

                    if(list.bank_code){this.agentForm.bank_code=list.bank_code;};      // 银行卡号
                    if(list.branch_bank){this.agentForm.branch_bank=list.branch_bank;};      // 分行名
                    if(list.bankSign && list.bank_prov){
                        this.$api.post('bank/branch', { bank_symbol: list.bankSign, bank_prov: list.bank_prov}, res => {
                            if (res.code == 0) {
                                this.agentForm.line_num = '';
                                this.branchList = [];
                                this.branchList = res.data.bank;
                                if(list.line_num){this.agentForm.line_num=list.line_num;};      // 联行号
                                if(list.bank_prov){this.agentForm.bank_prov=list.bank_prov;};      // 银行所在省
                                if(list.bankSign){this.agentForm.bankSign=list.bankSign;};      // 银行所在省
                            } else {
                                this.$message.error('获取支行信息失败，请重新选择银行或归属地进行获取!');
                            }
                        });
                    }
                    
                }
            })
        },
    }
}
</script>

<style scoped lang="scss">
.el-form-item {
    margin-bottom: 22px;
}
.m-title {
    color: #303133;
    font-size: 14px;
    font-weight: 700;
    padding-left: 10px;
    margin: 10px 0;
    border-left: 4px solid #409eff;
}
.line {
    text-align: center;
}
::v-deep .el-input-group__append {
    color: #ffffff;
    font-size: 12px;
    background-color: #409eff;
}
.el-form-item__content .el-input-group {
    vertical-align: middle;
}
.avatar-uploader {
    width: 200px;
    height: 130px;
    border-radius: 10px;
    overflow: hidden;
}
::v-deep .avatar-uploader .el-upload {
    width: 100%;
    height: 100%;
}
.avatar {
    width: 100%;
    height: 100%;
}
</style>
